import { Link } from 'react-router-dom';

export function SupportPage() {
    return (
        <>
            <section className="page-hero">
                <div className="content-wrapper py-4">
                    <h1 className="display-6 fw-semibold mb-3">Support</h1>
                    <p className='fs-3 mb-0'>Help Keep This Site Ad-Free</p>
                </div>
            </section>

            <div className="content-wrapper py-4">
                <div className="row g-4 mb-4">
                    <div className="col-12">
                        <h2>Web Hosting is Expensive. Ads suck.</h2>
                        <p>I built and maintain this platform because the Everquest is special to me and this platform is useful to the community. Please consider donating to support this site. Anything you can give to offset the cost of hosting and keep this site self-sustaining without ads is greatly appreciated.</p>
                        <div className='d-flex flex-row gap-4'>
                            <a href='https://ko-fi.com/winter_xo' className='btn btn-outline-secondary' target='_blank'>Ko-Fi</a>
                            <a href='https://www.patreon.com/c/winter_xo' className='btn btn-outline-secondary' target='_blank'>Patreon</a>
                        </div>
                        <p>Thank you so much!</p>
                        <p>&lt;3 Winter</p>
                    </div>
                </div>
            </div>
        </>
    );
}
